import { useEffect } from "react";
import { useState } from "react";

import { useTranslation } from "react-i18next";

import { useParams } from "react-router-dom";
import { Grid, Box, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DraftsIcon from "@mui/icons-material/Drafts";
import Tooltip from "@mui/material/Tooltip";
import ModalDialog from "../meters/ModalDialog";
import { store } from "../../redux/store";
import CopyTextButton from "./CopyTextButton";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import theme from "../../theme";
import { Tabs, Tab } from "@mui/material";
import { StyledDataGrid } from "../../pages/StyledDataGrid";
import { nameTransform, typeTransform } from "../../utils/utilsFunctions";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
function compareDates(a, b) {
  const dateA = new Date(a.attributes.message_date);
  const dateB = new Date(b.attributes.message_date);
  return dateB - dateA;
}
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};
const ReadedMeters = ({ idFromCondominium }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const gatewayId = useSelector((state) => state?.gatewaySlice?.gatewayId);
  const [message, setMessage] = useState(null);
  const [modalMessage, setModalMessage] = useState(false);
  const [value, setValue] = useState(0);
  const [page, setPage] = useState(1);
  const [unreadPage, setUnreadPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [allMessages, setAllMessages] = useState([]);
  const readedMessages = useSelector(
    (state) => state?.gatewaySlice?.readedMessages
  );
  const unreadedMessages = useSelector(
    (state) => state?.gatewaySlice?.unreadedMessages
  );
  const unreadedMessagesCount = useSelector(
    (state) => state?.gatewaySlice?.unreadedMessagesCount
  );
  const readedMessagesFirstRender = useSelector(
    (state) => state?.gatewaySlice?.readedMessagesFirstRender
  );
  const unreadedMessagesFirstRender = useSelector(
    (state) => state?.gatewaySlice?.unreadedMessagesFirstRender
  );
  const sortedMessagesByData = readedMessages?.slice()?.sort(compareDates);
  const handledMessages = useSelector(
    (state) => state?.gatewaySlice?.handledMeterMessages
  );
  const condominumId = useSelector((state) => state?.gatewaySlice?.gateway)
    ?.fields?.condominium_id;
  const unhandledMeterMesages =
    useSelector((state) => state?.gatewaySlice?.messages)?.filter(
      (item) => item?.attributes?.values?.values?.last_message_type === "data"
    )?.[0]?.attributes?.values?.values?.unhandled_meters ?? [];
  /*     const unhandledMeterMesages =
    useSelector((state) => state?.gatewaySlice?.messages)
      ?.filter(
        (item) => item?.attributes?.values?.values?.last_message_type === "data"
      )
      ?.filter(
        (item) => item.attributes?.values?.values?.unhandled_meters.length > 0
      )[0]?.attributes?.values?.values?.unhandled_meters ?? [];   */
  const transformName = (name) => {
    const nameInfo = name.split(":");
    const firstPart = parseInt(nameInfo[1], 16);
    const secondPart = parseInt(nameInfo[2], 16);
    const result = `${nameInfo[0]}:${firstPart}:${secondPart}`;

    return result;
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const transformedHandledMassages =
    handledMessages?.length > 0
      ? handledMessages?.map((obj) => ({
          ...obj,
          attributes: {
            device_id: obj.id,
            handled: true,
            values: {
              class: obj.attributes.class,
              serial_number: obj.attributes.serial_number,
              values: {
                condominium_name: obj.attributes.fields.condominium_name,
                apartment_name: obj.attributes.fields.apartment_name,
              },
            },
          },
        }))
      : [];
  const [getMessages] = store.useLazyGetMeterReadedMessagesQuery();

  const [getUnreadedMessages] = store.useLazyGetMeterUnreadedMessagesQuery();
  useEffect(() => {
    if (value == 0 && readedMessagesFirstRender && gatewayId) {
      getMessages(gatewayId);
    }
  }, [value, readedMessagesFirstRender, gatewayId]);
  useEffect(() => {
    if (value == 1 && unreadedMessagesFirstRender && gatewayId) {
      getUnreadedMessages({
        id: gatewayId,
        page: unreadPage,
        per_page: perPage,
      });
    }
  }, [value, unreadedMessagesFirstRender, gatewayId]);
  useEffect(() => {
    if (value == 1 && !unreadedMessagesFirstRender && gatewayId) {
      getUnreadedMessages({
        id: gatewayId,
        page: unreadPage,
        per_page: perPage,
      });
    }
  }, [unreadPage]);
  useEffect(() => {
    if (readedMessages /* && unhandledMeterMesages && handledMessages */) {
      setAllMessages([
        ...readedMessages,
        // ...transformedHandledMassages,
        // ...unhandledMeterMesages,
      ]);
    }
  }, [readedMessages /* unhandledMeterMesages, handledMessages */]);

  const styleSelector = (params) => {
    console.log("parix", params);
    const datastr = params.row.readTime;
    const date = new Date();
    console.log(date);
    /*     if (params?.row?.alarms?.length > 0 && params?.row?.alarms !== "--") {
      return `super-app-theme--Orange`;
    }
    if (params?.row?.dayDiff > 5) {
      return `super-app-theme--PartiallyFilled`;
    } */
    if (
      params?.row?.conid !== "--" &&
      params?.row?.conid !== condominumId &&
      params?.row?.conid !== ""
    ) {
      return `super-app-theme--Rejected`;
    }
    if (params.row.handled) {
      return `super-app-theme--Blue`;
    }
  };

  useEffect(() => {
    transformName("MAD:50:07");
  }, []);
  const onMailClick = (msg) => {
    setMessage(msg);
    setModalMessage(true);
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 90,
      sortable: false,
      flex: 1,
      hide: true,
    },
    {
      field: "handled",
      headerName: "handled",
      width: 90,
      sortable: false,
      flex: 1,
      hide: true,
    },
    {
      field: "conid",
      headerName: "conid",
      width: 90,
      sortable: false,
      flex: 1,
      hide: true,
    },

    {
      field: "device",
      headerName: t("Contatore"),
      type: "number",
      sortable: false,
      headerAlign: "left",
      flex: 3,
    },
    {
      field: "registry",
      headerName: t("registry"),
      type: "number",
      sortable: false,
      headerAlign: "left",
      flex: 3,
    },

    {
      field: "last_telegram",
      headerName: t("last_telegram"),
      type: "number",
      sortable: false,
      headerAlign: "left",
      flex: 3,
    },
    /* {
      field: "message_date",
      headerName: t("message_date"),
      type: "number",
      sortable: false,
      headerAlign: "left",
      flex: 3,
    }, */

    {
      field: "reading",
      headerName: t("reading"),
      type: "number",
      sortable: false,
      editable: false,
      headerAlign: "left",
      flex: 3,
    },
    {
      field: "calories",
      headerName: t("calories"),
      type: "number",
      sortable: false,
      editable: false,
      headerAlign: "left",
      flex: 3,
    },
    {
      field: "frigories",
      headerName: t("frigories"),
      type: "number",
      sortable: false,
      editable: false,
      headerAlign: "left",
      flex: 3,
    },
    {
      field: "unit",
      headerName: t("unit"),
      editable: false,

      editable: false,
      flex: 2,
    },
    {
      field: "actions",
      headerName: t("actions"),
      type: "number",
      sortable: false,
      editable: false,

      flex: 2,
      renderCell: (params) => {
        return (
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
          >
            {params.row.handled ? (
              <>
                {" "}
                {params.value.deviceId && (
                  <IconButton
                    onClick={() =>
                      window.open(`/meters/${params.value.deviceId}`, "_blank")
                    }
                  >
                    <VisibilityIcon />
                  </IconButton>
                )}
              </>
            ) : (
              <>
                {params.value.frame && (
                  <IconButton onClick={() => onMailClick(params.value)}>
                    <DraftsIcon />
                  </IconButton>
                )}
              </>
            )}
          </Box>
        );
      },
    },
  ];

  const renderDevice = (item) => {
    if (item && item.serial) {
      return `${item.manufacturer}:${item.version}:${typeTransform(
        item.type
      )}  ${item?.serial}`;
    } else if (item && item.attributes?.values?.class) {
      return `${item?.attributes?.values?.class} ${item?.attributes?.values?.serial_number}`;
    } else if (item && item.attributes?.values?.type) {
      return `${item?.attributes?.values?.manufacturer}:${
        item?.attributes?.values?.version
      }:${typeTransform(item?.attributes?.values?.type)} ${
        item?.attributes?.values?.serial
      }`;
    } else {
      return "na";
    }
  };

  const renderRegistry = (item) => {
    return item?.attributes &&
      item?.attributes?.values?.values?.condominium_name
      ? `COND ${item?.attributes?.values?.values?.condominium_name} - APP. ${item?.attributes?.values?.values?.apartment_name}`
      : "--";
  };
  const renderUnit = (unit) => {
    if (unit === "J") {
      return "";
    }
    if (unit === "Wh") {
      return "kWh";
    }
    if (unit == "m^3") {
      return "m³";
    }
    return unit;
  };
  const rows = sortedMessagesByData?.map((item, i) => ({
    id: i,
    device: renderDevice(item),
    //  item?.serial
    //   ? `${item.manufacturer}:${item.version}:${item.type}  ${item?.serial}`
    //   : `${item?.attributes?.values?.class} ${item?.attributes?.values?.serial_number}`,
    registry: renderRegistry(item),
    // item?.attributes &&
    //   item?.attributes?.values?.values?.condominium_name !== ""
    //   ? `COND ${item?.attributes?.values?.values?.condominium_name} - APP. ${item?.attributes?.values?.values?.apartment_name}`
    //   : "--",
    last_telegram: t("dt_n", { val: new Date(item?.attributes?.message_date) }),
    /* message_date: !item?.attributes?.values?.values
      ? t("dt_nr", {
          val: new Date(item?.attributes?.message_date),
        })
      : "--", */
    reading: item?.attributes?.values
      ? `${t("number", {
          val:
            item?.attributes?.values?.values?.value?.last_reading?.value ?? "-",
        })}`
      : "",
    frigories:
      item?.attributes?.values?.values?.value?.cold_last_reading?.value !== null
        ? item?.attributes?.values?.values?.value?.cold_last_reading?.unit ===
          "Wh"
          ? t("number", {
              val:
                item?.attributes?.values?.values?.value?.cold_last_reading
                  ?.value / 1000,
            })
          : t("number", {
              val: item?.attributes?.values?.values?.value?.cold_last_reading
                ?.value,
            })
        : "",
    calories:
      item?.attributes?.values?.values?.value?.heat_last_reading?.value !== null
        ? item?.attributes?.values?.values?.value?.heat_last_reading?.unit ===
          "Wh"
          ? t("number", {
              val:
                item?.attributes?.values?.values?.value?.heat_last_reading
                  ?.value / 1000,
            })
          : t("number", {
              val: item?.attributes?.values?.values?.value?.heat_last_reading
                ?.value,
            })
        : "",
    unit: renderUnit(
      item?.attributes?.values?.values?.value?.last_reading?.unit ??
        item?.attributes?.values?.values?.value?.heat_last_reading?.unit ??
        item?.attributes?.values?.values?.value?.cold_last_reading?.unit
    ),

    conid: item?.attributes?.values?.values?.condominium_id ?? "--",
    handled: item?.attributes?.values?.values ? true : false,
    actions: item?.attributes
      ? {
          deviceId: item?.attributes?.device_id,
          frame: item?.attributes?.values?.frame,
        }
      : {
          date: t("date_val", { val: new Date(item?.datetime_utc) }),
          frame: item?.attributes?.values?.frame,
        },
  }));
  const unreadColumns = [
    {
      field: "id",
      headerName: "ID",
      width: 90,
      sortable: false,
      flex: 1,
      hide: true,
    },

    {
      field: "device",
      headerName: t("Contatore"),
      type: "number",
      sortable: false,
      headerAlign: "left",
      flex: 2,
    },
    {
      field: "serial",
      headerName: t("serial"),
      type: "number",
      sortable: false,
      headerAlign: "left",
      flex: 2,
    },

    {
      field: "last_telegram",
      headerName: t("last_telegram"),
      type: "number",
      sortable: false,
      headerAlign: "left",
      flex: 3,
    },
    /*   {
      field: "address",
      headerName: t("address"),
      type: "number",
      sortable: false,
      headerAlign: "left",
      flex: 3,
    }, */

    {
      field: "actions",
      headerName: t("actions"),
      type: "number",
      sortable: false,
      editable: false,

      flex: 2,
      renderCell: (params) => {
        return (
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
          >
            <IconButton onClick={() => onMailClick(params?.value)}>
              <DraftsIcon />
            </IconButton>
          </Box>
        );
      },
    },
  ];
  const unreadRows = unreadedMessages?.map((item, i) => ({
    id: i,
    device:
      item?.attributes?.values?.values?.value?.manufacturer &&
      item?.attributes?.values?.values?.value?.version &&
      item?.attributes?.values?.values?.value?.type
        ? `${item?.attributes?.values?.values?.value?.manufacturer}:${
            item?.attributes?.values?.values?.value?.version
          }:${typeTransform(item?.attributes?.values?.values?.value?.type)}`
        : "NA",
    last_telegram: t("dt_n", { val: new Date(item?.attributes?.message_date) }),
    serial: item?.attributes?.values?.values?.value?.address,

    actions: item?.attributes?.values?.values?.value?.payload,
  }));
  useEffect(() => {
    console.log("readedMessages", rows);
  }, [rows]);
  useEffect(() => {
    console.log("mesaj", message);
  }, [message]);
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <ModalDialog
          open={modalMessage}
          close={() => setModalMessage(false)}
          title={"Message"}
        >
          <Box>
            <Typography variant="subtitle2">
              <pre
                style={{
                  overflow: "auto",
                  background: "#c0c0c0",

                  padding: "9px",
                }}
              >
                {JSON.stringify(message, null, 10)}
              </pre>
            </Typography>
            <CopyTextButton text={message?.frame ?? message} />
          </Box>
        </ModalDialog>
        <Box /* sx={{ borderBottom: 1, borderColor: "divider" }} */>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label={t("handled_meters")} />
            <Tab label={t("unhandled_meters")} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          {readedMessages?.length > 0 && (
            <Box sx={{ height: "60vh", width: "99%" }}>
              <StyledDataGrid
                getRowClassName={(params) => styleSelector(params)}
                disableColumnMenu
                rows={rows}
                columns={columns}
                rowCount={readedMessages?.length}
                pageSize={perPage}
                rowsPerPageOptions={[perPage]}
                disableSelectionOnClick
                onPageChange={(pageNumber) => {
                  setPage(pageNumber + 1);
                }}
                page={page - 1}
              />
            </Box>
          )}
          {readedMessages?.length === 0 && (
            <Box sx={{ mt: 7 }}>
              <Typography
                sx={{ color: theme.palette.primary.main }}
                variant="h3"
                align="center"
              >
                {t("no_available_data")}
              </Typography>
            </Box>
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          {unreadedMessages?.length > 0 && (
            <Box sx={{ height: "60vh", width: "99%" }}>
              <StyledDataGrid
                /*   getRowClassName={(params) => styleSelector(params)} */
                disableColumnMenu
                rows={unreadRows}
                columns={unreadColumns}
                rowCount={unreadedMessagesCount}
                pageSize={perPage}
                rowsPerPageOptions={[perPage]}
                disableSelectionOnClick
                onPageChange={(pageNumber) => {
                  setUnreadPage(pageNumber + 1);
                }}
                page={unreadPage - 1}
                paginationMode="server"
              />
            </Box>
          )}
          {unreadedMessages?.length === 0 && (
            <Box sx={{ mt: 7 }}>
              <Typography
                sx={{ color: theme.palette.primary.main }}
                variant="h3"
                align="center"
              >
                {t("no_available_data")}
              </Typography>
            </Box>
          )}
        </TabPanel>
      </Box>
    </>
  );
};
export default ReadedMeters;
